import React from 'react';
import { PRODUCTS } from './data';
import Product from './Product';

const Products = () => {
  return (
    <div className="flex flex-col sm:flex-row flex-wrap">
      {PRODUCTS.map((product, index) => (
        <Product key={`pi-${index}`} {...product} />
      ))}
    </div>
  )
}

export default Products;
